module.exports = __webpack_public_path__ + "img/chevron-left-icon.7a6ebfdf.svg";